module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-unactive-333aff6a.png";